import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import {
  Modal,
  Backdrop,
  Fade,
  IconButton,
  TextField,
  Button,
} from "@material-ui/core";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";

import EditIcon from "@material-ui/icons/Edit";
import { ucitajRase_rasa } from "../../generated/ucitajRase";

export const IZMENI_RASU = gql`
  mutation izmeniRasu($izmeniRasuInput: IzmeniRasuInput) {
    izmeniRasu(izmeniRasuInput: $izmeniRasuInput) {
      _id
    }
  }
`;

type PropTypes = {
  zaIzmenu: ucitajRase_rasa;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalForm: {
      width: 400,
      margin: "auto",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 400,
      },
    },
    button: {
      margin: theme.spacing(1),
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

export default function IzmeniRasu(props: PropTypes) {
  const resetRase = {
    opis: props.zaIzmenu.opis,
    napomena: props.zaIzmenu.napomena,
  };
  const classes = useStyles();

  const [izmeniRasu] = useMutation(IZMENI_RASU);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [buduciPodaci, setBuduciPodaci] = useState(resetRase);

  function otvoriFormuZaIzmenuRase() {
    setModalOpen(true);
  }

  function izmeniPodatkeRase(event: React.FormEvent) {
    event.preventDefault();
    izmeniRasu({
      variables: {
        izmeniRasuInput: { _id: props.zaIzmenu._id, ...buduciPodaci },
      },
      refetchQueries: ["ucitajRase"],
    });
    setModalOpen(false);
  }

  const onemogucenoDugme = buduciPodaci.opis === "";

  return (
    <>
      <IconButton
        onClick={() => {
          otvoriFormuZaIzmenuRase();
        }}
      >
        <EditIcon />
      </IconButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <div className={classes.paper}>
            <form
              className={classes.modalForm}
              noValidate
              autoComplete="off"
              onSubmit={(e: React.FormEvent) => {
                izmeniPodatkeRase(e);
              }}
            >
              <div>
                <TextField
                  required
                  id="opisZaIzmenu"
                  label="Opis"
                  variant="outlined"
                  value={buduciPodaci.opis}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setBuduciPodaci({
                      ...buduciPodaci,
                      opis: e.target.value,
                    })
                  }
                />
                <TextField
                  id="napomenaZaIzmenu"
                  label="Napomena"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows="4"
                  value={buduciPodaci.napomena}
                  onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setBuduciPodaci({
                      ...buduciPodaci,
                      napomena: e.target.value,
                    })
                  }
                />
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  type="submit"
                  disabled={onemogucenoDugme}
                >
                  Izmeni Rasu
                </Button>
              </div>
            </form>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
